<div
  class="d-flex"
  [ngClass]="{
    'justify-content-center': placement() === 'CENTER',
    'justify-content-end': placement() === 'RIGHT',
    'justify-content-start': placement() === 'LEFT',
  }">
  <div class="form-check form-check-reverse">
    <input
      type="checkbox"
      class="form-check-input"
      id="select-all-rows"
      [(ngModel)]="isAllSelected"
      commonSelectAllRows />
    <label class="form-check-label" for="select-all-rows" [ngClass]="{ 'fw-bold': labelBold }">{{ labelText() }}</label>
  </div>
</div>
